import { render, staticRenderFns } from "./LinkSection.vue?vue&type=template&id=e21e72f2&"
import script from "./LinkSection.vue?vue&type=script&lang=js&"
export * from "./LinkSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports